// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3YOBd","detailsBorder":"styles_detailsBorder__3faEB"};